<div class="flex flex-column gap-small pt-2">
    <app-text-input [form]="form" id="text" [label]="label"></app-text-input>
</div>

